import { render, staticRenderFns } from "./Canceled.vue?vue&type=template&id=18dd2e64&"
import script from "./Canceled.vue?vue&type=script&lang=js&"
export * from "./Canceled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports